/* ============================================================
   NEXUS ASSISTANT — KI-Chat-Widget mit Orb (10/2026)
   Markup: snippets/nexus-assistant.liquid · Optik: nexus-assistant.css
   Demo-Modus (config.demo=true): eingebaute Antworten + Routen-Erkennung.
   Live-Modus: POST config.endpoint (Shopify App Proxy -> app.nxus.ch),
   Vertrag: { messages:[{role,content}…max 10], seite } ->
            { antwort, aktion?:{typ:'route', route} }
   ============================================================ */
(function () {
  'use strict';

  var cfgEl = document.getElementById('nexusAssistantConfig');
  var root = document.getElementById('nexusAssistant');
  if (!cfgEl || !root) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var fab = document.getElementById('nxaFab');
  var fabOrb = document.getElementById('nxaFabOrb');
  var panel = document.getElementById('nxaPanel');
  var msgs = document.getElementById('nxaMsgs');
  var input = document.getElementById('nxaInput');
  var sugg = document.getElementById('nxaSugg');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var open = false, flying = false, busy = false, idleTimer = null, restored = false;
  var verlauf = []; /* {role, content} */

  /* ---------- Sitzung (§ 25 TDDDG: sessionStorage ERST nach Chat-Öffnung) ---------- */
  function ensureGespraech() {
    try {
      var id = sessionStorage.getItem('nxaGespraech');
      if (!id) {
        id = (window.crypto && crypto.randomUUID)
          ? crypto.randomUUID()
          : 'nx' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
        sessionStorage.setItem('nxaGespraech', id);
      }
      return id;
    } catch (e) { return 'nx-' + Date.now().toString(36); }
  }
  function saveVerlauf() {
    if (!open) return;
    try { sessionStorage.setItem('nxaVerlauf', JSON.stringify(verlauf)); } catch (e) {}
  }
  function restoreVerlauf() {
    if (restored) return; restored = true;
    try {
      var v = JSON.parse(sessionStorage.getItem('nxaVerlauf') || '[]');
      if (v.length) {
        verlauf = v.slice(-10);
        verlauf.forEach(function (m) {
          var b = bubble('', m.role === 'user' ? 'user' : 'bot');
          if (m.role === 'user') b.textContent = m.content; else b.innerHTML = md(m.content);
        });
        sugg.style.display = 'none';
      }
    } catch (e) {}
  }

  /* ---------- Einfaches, sicheres Markdown (fett, Listen, Links) ---------- */
  function md(s) {
    s = String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    s = s.replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>');
    s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+|\/[^)\s]+)\)/g, '<a href="$2">$1</a>');
    s = s.replace(/(^|[\s(])((?:https?:\/\/|nxus\.ch\/)[^\s<),]+)/g, function (m, p, u) {
      var href = u.indexOf('http') === 0 ? u : 'https://' + u;
      return p + '<a href="' + href + '">' + u + '</a>';
    });
    s = s.replace(/(^|\n)[-•]\s+/g, '$1&bull; ');
    s = s.replace(/\n/g, '<br>');
    return s;
  }
  /* Markdown für den Tipp-Effekt: offene **Fettschrift** schon während
     des Schreibens rendern statt rohe Sternchen zu zeigen */
  function mdLive(s) {
    var t = String(s);
    if (((t.match(/\*\*/g) || []).length) % 2 === 1) t += '**';
    return md(t);
  }

  /* ---------- Orb-Grundlagen ---------- */
  function orbs() { return root.querySelectorAll('.nxa-orb'); }
  orbs().forEach(function (o) {
    var e = document.createElement('div');
    e.className = 'nxa-eyes'; e.innerHTML = '<i></i><i></i>';
    o.appendChild(e);
  });

  function setOrb(state) {
    orbs().forEach(function (o) {
      o.dataset.state = state;
      if (state !== 'idle') { o.classList.remove('nxa-peek'); o.classList.remove('nxa-glance'); }
    });
  }

  /* Augen: alle ~5s blinzeln/zwinkern, ca. jedes 2. Mal neugieriger Blick */
  function peek() {
    if (reduceMotion || flying || document.hidden) return;
    var curious = Math.random() < 0.5;
    orbs().forEach(function (o) {
      if (o.dataset.state !== 'idle' || o.classList.contains('nxa-peek') || o.classList.contains('nxa-glance')) return;
      o.classList.add('nxa-peek');
      setTimeout(function () {
        o.classList.remove('nxa-peek');
        if (curious && o.dataset.state === 'idle' && !flying) {
          o.classList.add('nxa-glance');
          setTimeout(function () { o.classList.remove('nxa-glance'); }, 2800);
        }
      }, 2000);
    });
  }
  setInterval(peek, 5000);

  /* ---------- Panel ---------- */
  function togglePanel(force) {
    open = (typeof force === 'boolean') ? force : !open;
    panel.classList.toggle('nxa-open', open);
    fab.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      ensureGespraech();
      restoreVerlauf();
      setTimeout(function () { try { input.focus(); } catch (e) {} }, 300);
      if (!reduceMotion) setTimeout(peek, 450);
    } else {
      setOrb('idle');
    }
  }
  fab.addEventListener('click', function () { togglePanel(); });
  document.getElementById('nxaClose').addEventListener('click', function () { togglePanel(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) togglePanel(false); });

  input.addEventListener('input', function () {
    setOrb('listening');
    clearTimeout(idleTimer);
    idleTimer = setTimeout(function () { setOrb('idle'); }, 1800);
  });
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter') senden(); });
  document.getElementById('nxaSend').addEventListener('click', senden);
  sugg.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-frage]');
    if (!b) return;
    input.value = b.getAttribute('data-frage');
    senden();
  });

  function bubble(text, who) {
    var d = document.createElement('div');
    d.className = 'nxa-msg ' + (who === 'user' ? 'nxa-user' : 'nxa-bot');
    d.textContent = text;
    msgs.appendChild(d);
    msgs.scrollTop = msgs.scrollHeight;
    return d;
  }

  function tippen(an) {
    var alt = msgs.querySelector('.nxa-typing');
    if (alt) alt.remove();
    if (!an) return null;
    var t = document.createElement('div');
    t.className = 'nxa-typing'; t.innerHTML = '<i></i><i></i><i></i>';
    msgs.appendChild(t); msgs.scrollTop = msgs.scrollHeight;
    return t;
  }

  /* Antwort tippt sich wortweise ein; am Ende wird Markdown gerendert */
  function botAntwort(text, fertig) {
    setOrb('speaking');
    var b = bubble('', 'bot');
    if (reduceMotion) {
      b.innerHTML = md(text);
      msgs.scrollTop = msgs.scrollHeight;
      setTimeout(function () { setOrb('idle'); if (fertig) fertig(); }, 300);
      return;
    }
    var words = text.split(' '), i = 0;
    var iv = setInterval(function () {
      i++;
      b.innerHTML = mdLive(words.slice(0, i).join(' '));
      msgs.scrollTop = msgs.scrollHeight;
      if (i >= words.length) {
        clearInterval(iv);
        b.innerHTML = md(text);
        msgs.scrollTop = msgs.scrollHeight;
        setTimeout(function () { setOrb('idle'); }, 600);
        if (fertig) fertig();
      }
    }, 45);
  }

  /* ---------- Produktkarten (Variante B, Freigabe Halil 23.10.) ---------- */
  function renderProdukte(list) {
    if (!list || !list.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'nxa-cards';
    list.slice(0, 4).forEach(function (p) {
      var v = String(p.verfuegbarkeit || '');
      /* Ampel: zuerst das maschinenlesbare status-Feld (Backend ab 23.10.),
         sonst Fallback über den Klartext */
      var st = String(p.status || '');
      var cls = st === 'lieferbar' ? 'g'
        : st === 'zulauf' ? 'y'
        : st === 'anfrage' ? 'b'
        : st === 'nicht_lieferbar' ? 'x'
        : (/nicht|nur auf/i.test(v) ? 'x' : (/bestellt|anfrage/i.test(v) ? 'y' : (/lieferbar/i.test(v) ? 'g' : 'x')));
      var c = document.createElement('div'); c.className = 'nxa-card';
      var im = document.createElement('div'); im.className = 'nxa-card-im';
      if (p.bild) {
        var img = document.createElement('img'); img.src = p.bild; img.alt = ''; img.loading = 'lazy';
        img.onerror = function () { im.classList.add('nxa-ph'); im.textContent = '🖥️'; };
        im.appendChild(img);
      } else { im.classList.add('nxa-ph'); im.textContent = '🖥️'; }
      var bo = document.createElement('div'); bo.className = 'nxa-card-bo';
      var t = document.createElement('b'); t.textContent = p.titel || '';
      var meta = document.createElement('div'); meta.className = 'nxa-card-meta';
      var dot = document.createElement('i'); dot.className = 'nxa-dot ' + cls;
      meta.appendChild(dot); meta.appendChild(document.createTextNode(v));
      var pr = document.createElement('div'); pr.className = 'nxa-card-preis'; pr.textContent = p.preis || '';
      var go = document.createElement('button'); go.type = 'button'; go.className = 'nxa-card-go'; go.textContent = 'Ansehen';
      var ziel = (typeof p.url === 'string' && (p.url.indexOf('/') === 0 || p.url.indexOf('https://') === 0)) ? p.url : null;
      go.addEventListener('click', function (e) { e.stopPropagation(); if (ziel) location.href = ziel; });
      c.addEventListener('click', function () { if (ziel) location.href = ziel; });
      bo.appendChild(t); bo.appendChild(meta); bo.appendChild(pr); bo.appendChild(go);
      c.appendChild(im); c.appendChild(bo);
      wrap.appendChild(c);
    });
    msgs.appendChild(wrap);
    msgs.scrollTop = msgs.scrollHeight;
  }

  /* ---------- Demo-Wissen (bis das Backend live ist) ----------
     o = Routen-Angebot: sagt der Kunde danach "ja", fliegt der Orb dorthin */
  var lastOffer = null;
  var demoAntworten = [
    { k: /versand|lieferzeit|liefer|porto/i, o: 'versand', a: 'Gern! 🚚 Standardversand in Deutschland dauert **2–3 Werktage** und ist ab 50 € Bestellwert kostenlos (darunter 5,99 €). Express gibt es für 9,99 € mit 1–2 Werktagen. EU-Ausland: pauschal **24,99 €**, International **49,99 €** – Zoll und Einfuhrabgaben übernehmen dabei in der Regel wir. Ein PC mit Montage braucht insgesamt 3–5 Werktage. Soll ich dir die Versandseite zeigen?' },
    { k: /grafikkarte|gpu|budget/i, a: 'Gerne! 🎯 Sag mir kurz: Was ist dein Budget, und auf welcher Auflösung spielst du (1080p, 1440p oder 4K)? Hier schon mal ein Blick in unsere aktuelle Auswahl:', p: [
      { titel: 'MSI GeForce RTX 5070 Ventus 2X OC 12GB', preis: '649,95 €', verfuegbarkeit: 'lieferbar', url: '/collections/grafikkarten' },
      { titel: 'ASUS Prime GeForce RTX 5070 OC 12GB', preis: '679,00 €', verfuegbarkeit: 'lieferbar', url: '/collections/grafikkarten' },
      { titel: 'Gigabyte RTX 5070 Gaming OC 12GB', preis: '699,90 €', verfuegbarkeit: 'bestellt – bald lieferbar', url: '/collections/grafikkarten' }
    ] },
    { k: /gaming.?pc|zusammenstellen|zusammen bauen|konfigur|montage/i, o: 'konfigurator', a: 'Ja! 💪 Wir bauen Gaming-PCs komplett nach deinen Wünschen zusammen – inklusive professioneller Montage, Verkabelung und Systemtest. Am einfachsten startest du mit unserem PC-Konfigurator. Soll ich dir zeigen, wo du ihn findest?' },
    { k: /widerruf|zur&uuml;ckgeben|zurückgeben|r&uuml;ckgabe|rückgabe|retour/i, o: 'retoure', a: 'Du hast als Verbraucher 14 Tage Widerrufsrecht ab Erhalt der Ware. 📦 Eine Retoure kannst du direkt über unsere Retoure-Seite anmelden – soll ich dir zeigen, wo die ist?' },
    { k: /bestellstatus|wo ist meine bestellung|sendung|tracking/i, o: 'bestellungen', a: 'Deinen Bestellstatus und die Sendungsverfolgung findest du in deinem Konto unter „Meine Bestellungen". Soll ich dir zeigen, wo das ist? Alternativ hilft dir unser Team unter support@nxus.ch schnell weiter.' },
    { k: /rabatt|g&uuml;nstiger|günstiger|nachlass/i, o: 'aktionen', a: 'Rabatte kann ich leider keine verteilen 😇 – aber ein Blick auf unsere Aktionsseite lohnt sich, da gibt es regelmäßig echte Angebote direkt vom Distributor. Soll ich sie dir zeigen?' },
    { k: /.*/, o: 'kontakt', a: 'Gute Frage! Dazu habe ich gerade keine sichere Antwort – unser Team hilft dir aber schnell weiter: support@nxus.ch oder kostenlos 0800 2228444. Soll ich dir die Kontaktseite zeigen?' }
  ];

  function navIntent(q) {
    if (!/wo\s|zeig|finde|findet|bring mich/i.test(q)) return null;
    var s = q.toLowerCase();
    if (s.indexOf('bestellung') > -1) return 'bestellungen';
    if (s.indexOf('adresse') > -1) return 'adressen';
    if (s.indexOf('warenkorb') > -1 || s.indexOf('korb') > -1) return 'warenkorb';
    if (s.indexOf('such') > -1) return 'suche';
    if (s.indexOf('wunschliste') > -1 || s.indexOf('merkliste') > -1) return 'wunschliste';
    if (s.indexOf('konfigurator') > -1 || s.indexOf('wunsch-pc') > -1) return 'konfigurator';
    if (s.indexOf('kontakt') > -1) return 'kontakt';
    if (s.indexOf('retoure') > -1 || s.indexOf('rücksend') > -1) return 'retoure';
    if (s.indexOf('versand') > -1 || s.indexOf('lieferkosten') > -1 || s.indexOf('lieferzeit') > -1) return 'versand';
    if (s.indexOf('aktion') > -1 || s.indexOf('angebote') > -1 || s.indexOf('deals') > -1 || s.indexOf('reduziert') > -1) return 'aktionen';
    return null;
  }

  /* ---------- Senden ---------- */
  function senden() {
    var q = input.value.trim();
    if (!q || busy) return;
    busy = true;
    bubble(q, 'user');
    verlauf.push({ role: 'user', content: q });
    if (verlauf.length > 10) verlauf = verlauf.slice(-10);
    saveVerlauf();
    input.value = '';
    sugg.style.display = 'none';
    setOrb('thinking');
    var t = tippen(true);

    function abschliessen(text, routeId, prods) {
      tippen(false);
      verlauf.push({ role: 'assistant', content: text });
      if (verlauf.length > 10) verlauf = verlauf.slice(-10);
      saveVerlauf();
      botAntwort(text, function () {
        busy = false;
        renderProdukte(prods);
        if (routeId && cfg.routen && cfg.routen[routeId]) {
          setTimeout(function () { flyRoute(cfg.routen[routeId]); }, 400);
        }
      });
    }

    if (cfg.demo) {
      /* "ja/gern/ok" nach einem Routen-Angebot -> direkt hinfliegen */
      var folgeJa = /^(ja+|jo|yes|yep|klar|gern|gerne|ok|okay|bitte|los|zeig mir|mach das)\W*$/i.test(q) && lastOffer && cfg.routen[lastOffer];
      var routeId = folgeJa ? lastOffer : navIntent(q);
      if (routeId) lastOffer = null;
      setTimeout(function () {
        if (routeId) {
          var mehrstufig = cfg.routen[routeId] && cfg.routen[routeId].steps.length > 1;
          abschliessen(mehrstufig
            ? 'Na klar – ich führe dich Schritt für Schritt hin! ✨ Schau mir einfach hinterher …'
            : 'Na klar – komm, ich zeig’s dir! ✨ Schau mir einfach hinterher …', routeId);
        } else {
          var ans = demoAntworten.filter(function (d) { return d.k.test(q); })[0];
          lastOffer = ans.o || null;
          abschliessen(ans.a, null, ans.p || null);
        }
      }, routeId ? 700 : 1400 + Math.random() * 800);
      return;
    }

    /* Live-Modus: App Proxy */
    var timeout = setTimeout(function () {
      abschliessen('Hmm, das dauert gerade ungewöhnlich lange. Versuch es gleich nochmal – oder schreib uns an support@nxus.ch, da hilft dir unser Team persönlich.', null);
    }, 15000);

    fetch(cfg.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: verlauf, seite: location.pathname, gespraech: ensureGespraech() })
    }).then(function (r) {
      clearTimeout(timeout);
      if (r.status === 429) {
        r.json().then(function (d) {
          abschliessen((d && d.antwort) || 'Du schreibst gerade sehr schnell 😅 – versuch es bitte in einer Minute noch einmal.', null);
        }).catch(function () {
          abschliessen('Du schreibst gerade sehr schnell 😅 – versuch es bitte in einer Minute noch einmal.', null);
        });
        return null;
      }
      if (!r.ok) throw new Error('status ' + r.status);
      return r.json();
    }).then(function (data) {
      if (!data) return;
      var routeId = null;
      if (data.aktion && data.aktion.route && cfg.routen[data.aktion.route]) routeId = data.aktion.route;
      var prods = Array.isArray(data.produkte) ? data.produkte : null;
      abschliessen(String(data.antwort || '').slice(0, 4000) || 'Da ist etwas schiefgelaufen – frag mich gern nochmal.', routeId, prods);
    }).catch(function () {
      clearTimeout(timeout);
      abschliessen('Ich bin gerade nicht erreichbar. 🙈 Unser Team hilft dir sofort weiter: support@nxus.ch oder kostenlos 0800 2228444.', null);
    });
  }

  /* ---------- Orb-Navigation (Routen, auch mehrstufig) ---------- */
  function sichtbar(el) { return !!(el && el.getClientRects().length); }
  function findeZiel(selList) {
    for (var i = 0; i < selList.length; i++) {
      var el = document.querySelector(selList[i]);
      if (sichtbar(el)) return el;
    }
    return null;
  }

  function flyRoute(route) {
    if (flying) return;

    /* Schritte auflösen: "vorab"-Schritte nur, wenn das Endziel unsichtbar ist */
    var steps = [];
    for (var i = 0; i < route.steps.length; i++) {
      var s = route.steps[i];
      if (s.vorab) {
        var endziel = document.querySelector(s.vorab);
        if (sichtbar(endziel)) continue; /* Desktop: Vorab-Schritt überspringen */
      }
      steps.push(s);
    }
    if (!steps.length) return;
    var erstesZiel = findeZiel(steps[0].sel);
    if (!erstesZiel) {
      /* Kein sichtbares Flugziel: statt Flug einen Link in den Chat legen */
      if (route.ziel) {
        var b = bubble('', 'bot');
        b.innerHTML = '👉 <a href="' + route.ziel + '">Hier geht’s direkt zur Seite</a>';
        msgs.scrollTop = msgs.scrollHeight;
      }
      return;
    }

    flying = true;
    setOrb('idle');
    var cur = { x: 0, y: 0 };

    /* Reduzierte Bewegung: kein Flug — nur Spotlight + Hinweis am Ziel */
    if (reduceMotion) {
      var ziel = findeZiel(steps[steps.length - 1].sel) || erstesZiel;
      ziel.scrollIntoView({ block: 'nearest' });
      var ui = spotlight(ziel, (steps[steps.length - 1].tip || '') + '<button type="button">Verstanden</button>');
      var weg = function () { ui.s.remove(); ui.t.remove(); flying = false; };
      ui.t.querySelector('button').addEventListener('click', weg);
      setTimeout(weg, 6000);
      return;
    }

    function moveTo(target, done) {
      try { target.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
      setTimeout(function () {
        var fr = fab.getBoundingClientRect();
        var tr = target.getBoundingClientRect();
        var nx = cur.x + (tr.left + tr.width / 2) - (fr.left + fr.width / 2);
        var ny = cur.y + (tr.bottom + 44) - (fr.top + fr.height / 2);
        fab.classList.add('nxa-flying'); fabOrb.classList.add('nxa-fly');
        var a = fab.animate([
          { transform: 'translate(' + cur.x + 'px,' + cur.y + 'px) scale(1)' },
          { transform: 'translate(' + ((cur.x + nx) / 2) + 'px,' + (Math.min(cur.y, ny) - 130) + 'px) scale(1.07)', offset: 0.5 },
          { transform: 'translate(' + nx + 'px,' + ny + 'px) scale(.92)' }
        ], { duration: 1400, easing: 'cubic-bezier(.45,0,.2,1)', fill: 'forwards' });
        a.onfinish = function () { cur = { x: nx, y: ny }; fabOrb.classList.remove('nxa-fly'); done(); };
      }, 450);
    }

    function spotlight(target, tipHtml) {
      var r = target.getBoundingClientRect();
      var s = document.createElement('div'); s.className = 'nxa-spot';
      s.style.left = (r.left - 8) + 'px'; s.style.top = (r.top - 6) + 'px';
      s.style.width = (r.width + 16) + 'px'; s.style.height = (r.height + 12) + 'px';
      /* WICHTIG: in den Widget-Container hängen, nicht in body —
         sonst fehlen die CSS-Variablen (#nexusAssistant-Scope) und
         die Sprechblase wird transparent */
      root.appendChild(s);
      var t = document.createElement('div'); t.className = 'nxa-tip'; t.innerHTML = tipHtml;
      root.appendChild(t);
      var tw = t.getBoundingClientRect();
      var tl = r.left + r.width / 2 - tw.width / 2;
      tl = Math.max(12, Math.min(tl, window.innerWidth - tw.width - 12));
      t.style.left = tl + 'px'; t.style.top = (r.bottom + 86) + 'px';
      return { s: s, t: t };
    }

    function runStep(i) {
      var step = steps[i];
      var target = findeZiel(step.sel);
      if (!target) { returnHome(); return; }
      moveTo(target, function () {
        fabOrb.classList.add('nxa-hop');
        if (step.wait && i < steps.length - 1) {
          var ui = spotlight(target, step.tip + '<div class="nxa-tip-sub">👆 Einfach draufklicken – ich warte hier ^^</div>');
          var weiter = function () {
            target.removeEventListener('click', weiter);
            clearTimeout(abbruch);
            ui.s.remove(); ui.t.remove(); fabOrb.classList.remove('nxa-hop');
            setTimeout(function () { runStep(i + 1); }, 450);
          };
          target.addEventListener('click', weiter);
          /* Sicherheitsnetz: klickt niemand, fliegt der Orb nach 20s heim */
          var abbruch = setTimeout(function () {
            target.removeEventListener('click', weiter);
            ui.s.remove(); ui.t.remove(); fabOrb.classList.remove('nxa-hop');
            returnHome();
          }, 20000);
        } else {
          var ui2 = spotlight(target, step.tip + '<button type="button">Dorthin bringen ➤</button>');
          var fertig = function () {
            clearTimeout(auto);
            ui2.s.remove(); ui2.t.remove(); fabOrb.classList.remove('nxa-hop');
            returnHome();
          };
          var auto = setTimeout(fertig, 5000);
          ui2.t.querySelector('button').addEventListener('click', function () {
            try { target.click(); } catch (e) {}
            fertig();
          });
        }
      });
    }

    function returnHome() {
      fabOrb.classList.add('nxa-fly');
      var a = fab.animate([
        { transform: 'translate(' + cur.x + 'px,' + cur.y + 'px) scale(.92)' },
        { transform: 'translate(' + (cur.x / 2) + 'px,' + (Math.min(cur.y, 0) - 110) + 'px) scale(1.05)', offset: 0.5 },
        { transform: 'translate(0,0) scale(1)' }
      ], { duration: 1400, easing: 'cubic-bezier(.45,0,.25,1)', fill: 'forwards' });
      a.onfinish = function () {
        fab.classList.remove('nxa-flying'); fabOrb.classList.remove('nxa-fly');
        fabOrb.classList.add('nxa-peek');
        setTimeout(function () { fabOrb.classList.remove('nxa-peek'); }, 2000);
        cur = { x: 0, y: 0 }; flying = false;
      };
    }

    runStep(0);
  }
})();
